import { IItemForGetShortInfo } from 'types';
import React, { useCallback } from 'react';
import DraggableSelectedItem from 'components/SelectedItem/DraggableSelectedItem';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import style from './DnDList.module.scss';

interface IDnDList {
	setComboItems: (value: string[]) => void;
	selectedComboItems: string[];
	fetchedComboItems: IItemForGetShortInfo[];
}

const DnDList: React.FC<IDnDList> = ({ selectedComboItems, fetchedComboItems, setComboItems }) => {
	const handleDragEnd = useCallback(
		(result: DropResult) => {
			if (!selectedComboItems.length || !result.destination) {
				return null;
			}
			const items = selectedComboItems;
			const [reorderedItem] = items.splice(result.source.index, 1);
			items.splice(result.destination.index, 0, reorderedItem);
			setComboItems(items);
		},
		[selectedComboItems, setComboItems],
	);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedRestaurants = selectedComboItems.filter((el) => el !== id);
			setComboItems(updatedRestaurants);
		},
		[selectedComboItems, setComboItems],
	);

	return (
		<DragDropContext onDragEnd={handleDragEnd}>
			<Droppable droppableId="comboItemList">
				{(provided) => (
					<div className={style.groupsList} ref={provided.innerRef} {...provided.droppableProps}>
						{selectedComboItems.map((el, index) => (
							<Draggable key={el} draggableId={el} index={index}>
								{(provided) => {
									const label = fetchedComboItems.find((item) => item.id === el)?.name || '';
									return (
										<DraggableSelectedItem
											draggableInnerRef={provided.innerRef}
											provided={provided}
											positionNumber={index + 1}
											label={label}
											onDelete={() => handleRemove(el)}
										/>
									);
								}}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default React.memo(DnDList);
